import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import React from "react";
import { styled } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import { EBallotSelectionLabel, getBallotSelectionCount, getBallotSelectionLabel, } from "../../services/ReviewSummary";
import { getSlateName } from "../../services/Slates";
import { selectBallotSelectionByElectionId } from "../../store/ballotSelections/ballotSelectionsSlice";
import { useAppSelector } from "../../store/hooks";
var Count = styled("p")(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            width: "fit-content",
            margin: "0 0 16px auto",
            padding: "10px 13px",
            border: "1px solid #e7eaee",
            borderRadius: "7px",
            background: theme.palette.lightBackground,
            color: theme.palette.brandColor,
            fontSize: "14px",
            whiteSpace: "nowrap"
        },
        _b[theme.breakpoints.down("sm")] = {
            display: "none",
        },
        _b);
});
var Label = styled("p")(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            "display": "flex",
            "flexWrap": "wrap",
            "alignItems": "center",
            "gap": "6px 12px",
            "margin": "0 0 18px",
            "overflowWrap": "anywhere",
            "& strong": { fontSize: "14px" },
            "& span": { fontSize: "13px", color: theme.palette.customGrey.dark }
        },
        _b[theme.breakpoints.down("sm")] = {
            "& strong": { fontSize: "13px" },
            "& span": { fontSize: "12px" },
        },
        _b);
});
var useBallotCount = function (ballotStyle) {
    var selection = useAppSelector(selectBallotSelectionByElectionId(ballotStyle.election_id));
    return { selection: selection, count: getBallotSelectionCount(ballotStyle.ballot_eml.contests, selection) };
};
/** How many candidates the ballot holds, next to the ballot's title. */
export var SlateBallotCount = function (_a) {
    var ballotStyle = _a.ballotStyle;
    var t = useTranslation().t;
    var count = useBallotCount(ballotStyle).count;
    return (_jsx(Count, { className: "slate-selection-count", children: t("slates.count.short", { selected: count.selected, seats: count.seats }) }));
};
/** What the ballot holds as a whole, above the individual candidates. */
export var SlateSelectionLabel = function (_a) {
    var ballotStyle = _a.ballotStyle, slates = _a.slates, defaultLanguage = _a.defaultLanguage;
    var _b = useTranslation(), t = _b.t, i18n = _b.i18n;
    var _c = useBallotCount(ballotStyle), selection = _c.selection, count = _c.count;
    var label = getBallotSelectionLabel(slates, selection);
    var text = label.kind === EBallotSelectionLabel.SLATE && label.slate
        ? getSlateName(label.slate, i18n.language, defaultLanguage)
        : t("slates.count.".concat(label.kind));
    return (_jsxs(Label, { className: "slate-selection-label slate-selection-label-".concat(label.kind), children: [_jsx("strong", { className: "slate-selection-label-name", children: text }), _jsx("span", { className: "slate-selection-label-count", children: t("slates.count.long", { selected: count.selected, seats: count.seats }) })] }));
};
